import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../css/styles.css";
import Suggestion from "../Suggestion/index.js";
import VendorShape from "../../shapes/VendorShape.js";

var LocalSuggestion = function LocalSuggestion(_ref) {
  var _context, _context2;

  var suggestion = _ref.suggestion;
  var _suggestion$location$ = suggestion.location.address,
      address1 = _suggestion$location$.address1,
      city = _suggestion$location$.city,
      state = _suggestion$location$.state;
  return React.createElement(Suggestion, {
    main: React.createElement("div", null, React.createElement("span", null, suggestion.name, " - "), React.createElement("span", {
      className: styles['vendor-category']
    }, suggestion.categoryNames.join(' '))),
    secondary: _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "\n        ".concat(address1 ? "".concat(address1, ",") : '', "\n        ")).call(_context2, city, ",\n        ")).call(_context, state, "\n      ")
  });
};

process.env.NODE_ENV !== "production" ? LocalSuggestion.propTypes = {
  suggestion: PropTypes.shape(VendorShape).isRequired
} : void 0;
export default LocalSuggestion;